import React from 'react';
import { Link } from 'react-router-dom';

const FooterThree = () => {
  return (
    <footer>
      <div className="tp-footer__area black-bg">
        <div className="tp-footer">
          {/* <!-- main-footer start  --> */}
          <div className="tp-footer__main">
            <div className="container">
              <div className="tp-footer-border pt-100 pb-70">
                <div className="pb-30 pb-70">
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <div className="footer-logo mb-30">
                        <Link to="/" href="#"><img src="/assets/img/logo/Onfon Media White logo-2.png" alt="" /></Link>
                      </div>
                    </div>
                    <div className="col-12 col-md-6 text-end">
                      <div className="footer-form-2 mb-30">
                        <form>
                          <input type="email" placeholder="Enter your mail" />
                          <button type="submit">Subscribe <i
                            className="fal fa-paper-plane"></i></button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-3 col-md-6">
                    <div className="tp-footer__widget tp-footer__2 pb-30">
                      <h3 className="tp-footer__widget-title text-white">Onfon Media Group of Companies</h3>
                      <ul>
                        <li><a href="https://onfonmobile.com/" target="_blank">Onfon Mobile Kenya</a></li>
                        <li><a href="https://onfonmobile.co.za/" target="_blank">Onfon Mobile South Africa</a></li>
                        <li><a href="https://onfonmobile.co.tz/" target="_blank">Onfon Mobile Tanzania</a></li> 
                        <li><a href="https://onfonmobile.co.ls/" target="_blank">Onfon Mobile Lesotho</a></li>
                        <li><a href="https://onfonmobile.co.mz/" target="_blank">Onfon Mobile Mozambique</a></li>
                        <li><a href="https://onfonmobile.et/" target="_blank">Onfon Mobile Ethiopia</a></li>
                        <li><a href="https://onfonmobile.co.dr/" target="_blank">Onfon Mobile DRC</a></li>
                        <li><a href="https://onfonmobile.co.ng/" target="_blank">Onfon Mobile Nigeria</a></li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="tp-footer__widget tp-footer__2 pb-30">
                      <h3 className="tp-footer__widget-title text-white">Onfon Media Related Companies</h3>
                      <ul>
                        <li><a href="https://credofaster.co.ke/" target="_blank">Credo Faster</a></li>
                        <li><a href="https://mobipesa.co.ke/" target="_blank">Mobipesa</a></li>
                        <li><a href="https://innovexsolutions.co.ke/" target="_blank">Innovex</a></li>
                        <li><a href="https://infotrace.com/" target="_blank">Infotrace</a></li>
                        <li><a href="https://digitalsacco.com/" target="_blank">Digital Sacco</a></li>
                        <li><a href="https://okoafloat.com/" target="_blank">Okoa Float</a></li>
                        <li><a href="https://digitalaggregates.com/" target="_blank">Digital Media Aggregators</a></li>
                        <li><a href="https://okoabia.co.ke/" target="_blank">Okoa Bia</a></li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 ">
                    <div className="tp-footer__widget tp-footer__2  pb-30">
                      <h3 className="tp-footer__widget-title text-white">Resources</h3>
                      <ul>
                        <li><a href="/contact">Support</a></li>
                        <li><a href="https://portal.onfonmedia.co.ke/" target="_blank">Portal</a></li>
                        <li><a href="/service">Services</a></li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="tp-footer__widget tp-footer__2  pb-30">
                      <h3 className="tp-footer__widget-title text-white">Legal</h3>
                      <ul>
                        <li><a href="">Terms & Condition</a></li>
                        <li><a href="">Privacy Policy</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- main footer end  --> */}
        </div>
      </div>

      {/* <!-- footer copy right --> */}
      <div className="top-footer-copyright pt-30 pb-30 black-bg">
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-12">
              <div className="tp-copyrigh-text mb-30">
                <span>© {new Date().getFullYear()} Onfon Media ||  Informing . Entertaining . Inspiring . All Rights Reserved.</span>
              </div>
            </div>
            <div className="col-md-4 col-12">
              <div className="tp-footer-social-icon mb-30 text-md-end">
              <ul>
                  <li><a href="https://www.facebook.com/onfonmedial"><i className="fab fa-facebook"></i></a></li>
                  <li><a href="https://x.com/onfonmedia"><i className="fab fa-twitter"></i></a></li>
                  <li><a href="https://www.instagram.com/onfonmedial/"><i className="fab fa-instagram"></i></a></li>
                  <li><a href="https://www.youtube.com/@onfonmedialimited"><i className="fab fa-youtube"></i></a></li>
                  <li><a href="https://www.linkedin.com/company/onfon-media-limited/posts/?feedView=all"><i className="fab fa-linkedin"></i></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- footer copyright end  --> */}
    </footer>
  );
};

export default FooterThree;